import './coladacubancafe/style';
import FormStructure from './coladacubancafe/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js